export const data = {
  products: [
    {
      id: 1,
      name: "Wild Rider Layers Unisex Sneakers",
      price: 121,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/380697/02/sv01/fnd/IND/fmt/png/,Wild-Rider-Layers-Unisex-Sneakers",
      description:
        "With design elements inspired by the movement and motion of city life, the Wild Rider Layers Unisex Sneakers brings a fresh new dimension to the iconic Rider family. We've layered a rich mix of premium leather, suede and hairy suede onto a nylon upper to create texture and a raw edgy look that is pure street. The IMEVA midsole and rubber outsole ensure combined lightweight comfort and great traction to take you forward, further and faster through your day and beyond.",
      quantity: 1,
      color: "white",
      type: "sneakers",
      rating: 1,
    },
    {
      id: 2,
      name: "Mercedes Kart Cat-X Tech Unisex Sneakers",
      price: 151,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_750,h_750/global/306557/01/sv01/fnd/IND/fmt/png/Mercedes-Kart-Cat-X-Tech-Unisex-Sneakers",
      description:
        "Premium material and tech features are given a branded boost from German engineering. The Mercedes Kart Cat-X Tech Unisex Sneakers areleant style and esteem by Mercedes-AMG Petronas Motorsport. The piece rises to the occasion with an all-leather upper.",
      quantity: 1,
      color: "black",
      type: "sneakers",
      rating: 1,
    },
    {
      id: 3,
      name: "Jako Slip-On Men's Shoes",
      price: 161,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_750,h_750/global/381374/01/sv01/fnd/IND/fmt/png/Jako-Slip-On-Men's-Shoes",
      description:
        "The Jako Slip-On Men's Shoes are perfect for a laceless running style. Lightweight and styled for everyday wear, they feature a breathable and durable mesh upper. Layered cushioning adds comfort that goes the distance.",
      quantity: 1,
      color: "black",
      type: "shoes",
      rating: 1,
    },
    {
      id: 4,
      name: "PUMA Serve Pro Lite Unisex shoes",
      price: 261,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/374902/01/sv01/fnd/IND/fmt/png/PUMA-Serve-Pro-Lite-Unisex-Shoes",
      description:
        "Catering to the growing consumer expectation for casual, everyday comfort, the Serve Pro Lite Trainers feature shock-absorbing support for lightweight luxury.",
      quantity: 1,
      color: "white",
      type: "shoes",
      rating: 1,
    },
    {
      id: 5,
      name: "Electron E Unisex Shoes",
      price: 321,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/380435/04/sv01/fnd/IND/fmt/png/Electron-E-Unisex-Shoes",
      description:
        "There's more to the Electron E Trainers than meets the eye. Its visible technology highlights fantastic features like a breathable mesh upper, synthetic quarter panels for support and a bold aesthetic that's both fun and futuristic. The elastic band on the heel provides extra comfort.",
      quantity: 1,
      color: "red",
      type: "shoes",
      rating: 2,
    },
    {
      id: 6,
      name: "one8 Virat Kohli Basket Classice Unisex Sneakers",
      price: 371,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/375314/01/sv01/fnd/IND/fmt/png/one8-Virat-Kohli-Basket-Classic-Unisex-Sneakers",
      description:
        "This one is for the collectors,connoisseur & extreme uber cool, the one8 Virat Kohli Basket Classic one8 V3 pays homage to the illustrious career of the legend himslef",
      quantity: 1,
      color: "white",
      type: "sneakers",
      rating: 2,
    },
    {
      id: 7,
      name: "Caracal SoftFoam+Sneakers",
      price: 171,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/369863/18/sv01/fnd/IND/fmt/png/Caracal-SoftFoam+-Sneakers",
      description:
        "Long, clean lines, a premium leather upper and a tennis-inspired silhouette make the Caracal Sneakers your go-to for sleek style, whether you're on or off the court.",
      quantity: 1,
      color: "white",
      type: "sneakers",
      rating: 2,
    },
    {
      id: 8,
      name: "Mirage Mox Brightly Packed Shoes",
      price: 271,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/375168/01/sv01/fnd/IND/fmt/png/Mirage-Mox-Brightly-Packed-Shoes",
      description:
        "The Mirage Mox takes design cues from a 1970s pair of PUMA running shoes and transforms them with textural contrasts, pops of colour and funky futuristic elements. Inspired by illusions and the space between what's real and otherworldly, it's ready for new realities. Incorporating caution tape elements for a deconstructed approach to this season's trends, the Brightly Packed iteration features premium materials for a sophisticated silhouette that will have you rocking retro with cool confidence",
      quantity: 1,
      color: "other",
      type: "shoes",
      rating: 2,
    },
    {
      id: 9,
      name: "Future Rider Play On Unisex Sneakers",
      price: 571,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/371149/69/sv01/fnd/IND/fmt/png/Future-Rider-Play-On-Unisex-Sneakers",
      description:
        "Keep the game going in the shoe that launched a movement, our Future Rider Play On Unisex Sneakers. This shoe is dedicated to pared-down performance, featuring a super-light nylon, suede and leather upper and our famous shock-absorbing Federbein outsole to keep you pounding the pavement in style.",
      quantity: 1,
      color: "other",
      type: "sneakers",
      rating: 3,
    },
    {
      id: 10,
      name: "Anzarun Lite Unisex Sneakers",
      price: 671,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/371128/23/sv01/fnd/IND/fmt/png/Anzarun-Lite-Unisex-Sneakers",
      description:
        "The freshest look for any occasion, the Anzarun Lite Trainers are PUMA's most refined shoe yet. Featuring the breezy Anzarun DNA mesh upper, a cushy SoftFoam+ sockliner and discreet PUMA branding throughout, you're sure to look great, wherever the day takes you.",
      quantity: 1,
      color: "other",
      type: "sneakers",
      rating: 3,
    },
    {
      id: 11,
      name: "Pacer Next Cage Shoes",
      price: 371,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/365284/01/sv01/fnd/IND/fmt/png/Pacer-Next-Cage-Shoes",
      description:
        "With a foot-hugging mesh upper and a supportive lace-through midfoot caging system, the Pacer Next Cage has a sleek silhouette that is as ready for the gym as it is for the streets. A feather-light midsole provides superior energy return, cushioning and support, while slip-on construction adds a sock-like rather than a shoe-like feel. You wont want to leave home in anything else.",
      quantity: 1,
      color: "black",
      type: "shoes",
      rating: 3,
    },
    {
      id: 12,
      name: "Rebound Lay-Up Lo SoftFoam+Mesh Shoes",
      price: 971,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_600,h_600/global/370914/01/sv01/fnd/IND/fmt/png/Rebound-Lay-Up-Lo-SoftFoam+-Mesh-Shoes",
      description:
        "Rethink the basketball trainer with the Rebound Lay-Up. This versatile sneaker features a mesh upper for superior breathability and a SoftFoam+ sockliner to give you a supportive fit. Paired with the iconic PUMA Formstrip, you will  have classic style with all of the innovation of today.",
      quantity: 1,
      color: "white",
      type: "shoes",
      rating: 3,
    },
    {
      id: 13,
      name: "one8 Virat Kohli Basket Classic Unisex Sneakers",
      price: 451,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_1500,h_1500/global/375314/02/sv01/fnd/IND/fmt/png/one8-Virat-Kohli-Basket-Classic-Unisex-Sneakers",
      description:
        "This one is for the collectors,connoisseur & extreme uber cool, the one8 Virat Kohli Basket Classic one8 V3 pays homage to the illustrious career of the legend himslef",
      quantity: 1,
      color: "black",
      type: "sneakers",
      rating: 4,
    },
    {
      id: 14,
      name: "PUMA x 1DER Columbus Men's Shoes",
      price: 271,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_2000,h_2000/global/387768/01/sv01/fnd/IND/fmt/png/PUMA-x-1DER-Columbus-Men's-Shoes",
      description:
        "Crafted for the ones who love an active life while looking stylish, PUMA and KL Rahul bring you the Columbus Men's Shoes. Enveloping KL Rahul's bold and sophisticated style, the contrasting overlays add edge to the overall look of PUMA x 1DER Columbus Men's Shoes. Even though the PUMA and 1DER logos are subtle, they are unmissable.",
      quantity: 1,
      color: "red",
      type: "shoes",
      rating: 4,
    },
    {
      id: 15,
      name: "BMW M Motorsport City Rider Sneakers",
      price: 556,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_1500,h_1500/global/306975/01/sv01/fnd/IND/fmt/png/BMW-M-Motorsport-City-Rider-Sneakers",
      description:
        "Live life grand with the BMW M Motorsport City Rider Unisex Sneakers. Featuring the signature Rider outsole in combination with the BMW branding. The stunning design adds the edge that'll make any casual look appear out of the world",
      quantity: 1,
      color: "black",
      type: "sneakers",
      rating: 4,
    },
    {
      id: 16,
      name: "Jamming FUSEFIT Evolution Shoes",
      price: 771,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_750,h_750/global/366545/01/sv01/fnd/IND/fmt/png/Jamming-FUSEFIT-Evolution-Shoes",
      description:
        "Inspired by Spacewalk, the Jamming FUSEFIT Evolution Sneakers take the next step in futuristic design and technology. The combined outsole features a TPU membrane that encapsulates free-floating EVA beads for superior cushioning and the feeling of walking on sand. A unique lacing system gives you endless possibilities for comfort and style. With versatile and adaptive features, these sneakers are the perfect way to overcome any obstacle and propel yourself into new worlds.",
      quantity: 1,
      color: "black",
      type: "shoes",
      rating: 4,
    },
    {
      id: 17,
      name: "Puma Perforated Low Men's Shoes",
      price: 871,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_1050,h_1050/global/372981/01/sv01/fnd/IND/fmt/png/Puma-Perforated-Low-Men's--IDP-Shoes",
      description:
        "Be street ready with the Puma Perforated Low Men's Shoes perfect for leisure and slaying around.",
      quantity: 1,
      color: "white",
      type: "shoes",
      rating: 5,
    },
    {
      id: 18,
      name: "RS-X TOYS Unisex Sneakers",
      price: 971,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_750,h_750/global/369449/24/sv01/fnd/IND/fmt/png/RS-X-TOYS-Unisex-Sneakers",
      description:
        "Based on PUMAs innovative Running System technology, the RS-X line draws its design inspiration from the decade that had the best toys ever, hands down, bar none: the 1980s. Specifically, these RS-X TOYS Unisex Sneakers play on the trend of the toys of our childhood ultimately becoming collectors items down the road. The mesh upper on these Sneakers promote air flow, and features colours that would be at home in a crowded video arcade from 30 years ago. A unique cushioning function provides support, and the rubber outsole offers supreme traction and grip.",
      quantity: 1,
      color: "other",
      type: "sneakers",
      rating: 5,
    },
    {
      id: 19,
      name: "X-RAY² Ramble Unisex Shoes",
      price: 271,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_750,h_750/global/380727/06/sv01/fnd/IND/fmt/png/X-RAY%C2%B2-Ramble-Unisex-Shoes",
      description:
        "Take to the urban outdoors in the X-Ray² Ramble Trainers. PUMAs signature street style just got rugged, with technical fabrics like ripstop and suede, robust eyestay webbing straps and discreet branding. So, of course, the shoe looks fierce - but with the full-on comfort of Softfoam+, this hiking hybrid feels amazing too.",
      quantity: 1,
      color: "other",
      type: "shoes",
      rating: 5,
    },
    {
      id: 20,
      name: "RS-X³ Twill Air Mesh Shoes",
      price: 171,
      image:
        "https://images.puma.com/image/upload/f_auto,q_auto,b_rgb:fafafa,w_1500,h_1500/global/368845/02/sv01/fnd/IND/fmt/png/RS-X%C2%B3-Twill-Air-Mesh-Shoes",
      description:
        "Dare to be bold. We've rebooted the RS design to take it to a whole new level. We've stripped it back to down basics and rebuilding it with more extreme mixes of colour and materials for a 3x stronger retro-meets-the-future look. PUMA's Running System is the engine under the bonnet, providing comfort and cushioning with every step.",
      quantity: 1,
      color: "other",
      type: "shoes",
      rating: 5,
    },
    {
      id: 21,
      name: "Sl 20.2 Shoes",
      price: 871,
      image:
        "https://assets.adidas.com/images/w_600,f_auto,q_auto/ad53e2abade1464bb0dcad0c00aaafec_9366/SL20.2_Shoes_Orange_Q46187_01_standard.jpg",
      description:
        "Dare to be bold. We've rebooted the RS design to take it to a whole new level. We've stripped it back to down basics and rebuilding it with more extreme mixes of colour and materials for a 3x stronger retro-meets-the-future look. PUMA's Running System is the engine under the bonnet, providing comfort and cushioning with every step.",
      quantity: 1,
      color: "orange",
      type: "shoes",
      rating: 5,
    },
    {
      id: 22,
      name: "ZX 2K Boost 2.0 Trail Shoes",
      price: 571,
      image:
        "https://assets.adidas.com/images/w_600,f_auto,q_auto/06dcf7e2969045b48da6ad5500f501bf_9366/ZX_2K_Boost_2.0_Trail_Shoes_Green_GZ7784_01_standard.jpg",
      description:
        "The daily commute. The walk to the coffee shop. The off hours when you're free to roam. When life takes you out into the city, these adidas shoes help you cruise. Built on the innovative ZX line and infused with the technical vibe of trail shoes, they have a responsive Boost midsole, a grippy outsole and a warm lining. We're talking all-day comfort here.",
      quantity: 1,
      color: "other",
      type: "shoes",
      rating: 5,
    },
    {
      id: 24,
      name: "PREDATOR FREAK .3 FG J",
      price: 1571,
      image:
        "https://assets.adidas.com/images/w_600,f_auto,q_auto/ae95d399b7d446a4afd7ac7700d4d30d_9366/PREDATOR_FREAK_.3_FG_J_Black_FW7530_01_standard.jpg",
      description:
        "Dare to be bold. We've rebooted the RS design to take it to a whole new level. We've stripped it back to down basics and rebuilding it with more extreme mixes of colour and materials for a 3x stronger retro-meets-the-future look.",
      quantity: 1,
      color: "other",
      type: "sneakers",
      rating: 5,
    },
    {
      id: 25,
      name: "Defiant Generation multicourt tennis shoes",
      price: 971,
      image:
        "https://assets.adidas.com/images/w_600,f_auto,q_auto/49a9781d4d9c46629e9dabad00dd154b_9366/Defiant_Generation_multicourt_tennis_shoes_Pink_FX5814_01_standard.jpg",
      description:
        "Who says you can't have it all? Lace up these adidas Defiant Generation tennis shoes to raise your game. The foot-hugging upper and cushioned midsole combine to keep you comfortable as you express yourself on the court. The durable outsole and abrasion-resistant toe easily stand up to your all-action game.",
      quantity: 1,
      color: "orange",
      type: "shoes",
      rating: 5,
    },
  ],
  teamMembers: [
    {
      login: "Ronaldo",
      bio: "Front-end Developer",
      id: 1,
      node_id: "MDQ6VXNlcjE=",
      avatar_url: "https://avatars.githubusercontent.com/u/1?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/mojombo",
      html_url: "https://github.com/mojombo",
      followers_url: "https://api.github.com/users/mojombo/followers",
      following_url:
        "https://api.github.com/users/mojombo/following{/other_user}",
      gists_url: "https://api.github.com/users/mojombo/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/mojombo/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/mojombo/subscriptions",
      organizations_url: "https://api.github.com/users/mojombo/orgs",
      repos_url: "https://api.github.com/users/mojombo/repos",
      events_url: "https://api.github.com/users/mojombo/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/mojombo/received_events",
      type: "User",
      site_admin: false,
    },
    {
      login: "defunkt",
      id: 2,
      bio: "Back-end Developer",
      node_id: "MDQ6VXNlcjI=",
      avatar_url: "https://avatars.githubusercontent.com/u/2?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/defunkt",
      html_url: "https://github.com/defunkt",
      followers_url: "https://api.github.com/users/defunkt/followers",
      following_url:
        "https://api.github.com/users/defunkt/following{/other_user}",
      gists_url: "https://api.github.com/users/defunkt/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/defunkt/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/defunkt/subscriptions",
      organizations_url: "https://api.github.com/users/defunkt/orgs",
      repos_url: "https://api.github.com/users/defunkt/repos",
      events_url: "https://api.github.com/users/defunkt/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/defunkt/received_events",
      type: "User",
      site_admin: false,
    },
    {
      login: "pjhyett",
      id: 3,
      bio: "Bank Manager",
      node_id: "MDQ6VXNlcjM=",
      avatar_url: "https://avatars.githubusercontent.com/u/3?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/pjhyett",
      html_url: "https://github.com/pjhyett",
      followers_url: "https://api.github.com/users/pjhyett/followers",
      following_url:
        "https://api.github.com/users/pjhyett/following{/other_user}",
      gists_url: "https://api.github.com/users/pjhyett/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/pjhyett/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/pjhyett/subscriptions",
      organizations_url: "https://api.github.com/users/pjhyett/orgs",
      repos_url: "https://api.github.com/users/pjhyett/repos",
      events_url: "https://api.github.com/users/pjhyett/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/pjhyett/received_events",
      type: "User",
      site_admin: false,
    },
    {
      login: "wycats",
      id: 4,
      bio: "Product designer",
      node_id: "MDQ6VXNlcjQ=",
      avatar_url: "https://avatars.githubusercontent.com/u/4?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/wycats",
      html_url: "https://github.com/wycats",
      followers_url: "https://api.github.com/users/wycats/followers",
      following_url:
        "https://api.github.com/users/wycats/following{/other_user}",
      gists_url: "https://api.github.com/users/wycats/gists{/gist_id}",
      starred_url: "https://api.github.com/users/wycats/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/wycats/subscriptions",
      organizations_url: "https://api.github.com/users/wycats/orgs",
      repos_url: "https://api.github.com/users/wycats/repos",
      events_url: "https://api.github.com/users/wycats/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/wycats/received_events",
      type: "User",
      site_admin: false,
    },
    {
      login: "ezmobius",
      id: 5,
      bio: "Product developer",
      node_id: "MDQ6VXNlcjU=",
      avatar_url: "https://avatars.githubusercontent.com/u/5?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/ezmobius",
      html_url: "https://github.com/ezmobius",
      followers_url: "https://api.github.com/users/ezmobius/followers",
      following_url:
        "https://api.github.com/users/ezmobius/following{/other_user}",
      gists_url: "https://api.github.com/users/ezmobius/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/ezmobius/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/ezmobius/subscriptions",
      organizations_url: "https://api.github.com/users/ezmobius/orgs",
      repos_url: "https://api.github.com/users/ezmobius/repos",
      events_url: "https://api.github.com/users/ezmobius/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/ezmobius/received_events",
      type: "User",
      site_admin: false,
    },
  ],
  contact: [
    {
      id: 1,
      email: "jobs",
      work: "to work with us",
    },
    {
      id: 2,
      email: "info",
      work: "for more information",
    },
    {
      id: 3,
      email: "feedbacks",
      work: "to send feedback",
    },
    {
      id: 4,
      email: "support",
      work: "for any technical support",
    },
  ],
};
